// extracted by mini-css-extract-plugin
export var addOn = "FeatureTable-module--add-on--99aa6";
export var allFeatures = "FeatureTable-module--all-features--72e38";
export var arrow = "FeatureTable-module--arrow--9adaa";
export var check = "FeatureTable-module--check--5e32f";
export var feature = "FeatureTable-module--feature--0ddb5";
export var featuresGrid = "FeatureTable-module--features-grid--31742";
export var flip = "FeatureTable-module--flip--6b80d";
export var grid = "FeatureTable-module--grid--43598";
export var heading = "FeatureTable-module--heading--3edcf";
export var noPadding = "FeatureTable-module--no-padding--e420d";
export var row = "FeatureTable-module--row--614d7";
export var tierHeading = "FeatureTable-module--tier-heading--68337";
export var title = "FeatureTable-module--title--eb356";
export var toolTipWrap = "FeatureTable-module--tool-tip-wrap--470d2";